<div class="card title-card mb-4">
  <div class="flex align-items-center">
    <i [class.pi-pencil]="mode === 'edit'" [class.pi-plus-circle]="mode === 'create'"
       class="pi mr-1 title-card-icon"></i>
    <p class="mb-0 text-3xl title">
      {{ (mode === 'create' ? 'misc.creation.assetRepresentation' : 'misc.edition.assetRepresentation') | transloco | capitalize }}
    </p>
  </div>
</div>
<div class="card step-card flex flex-column">
  <form *ngIf="representationForm" [formGroup]="representationForm">
    <div class="grid">

      <div class="col-12 md:col-12 lg:col-6 xl:col-4">
        <div class="form-field col-12">
          <label for="name">{{ 'attribute.name' | transloco }} (*)</label>
        </div>
        <div class="col-12">
          <input class="w-full" formControlName="name" id="name" pInputText type="text">
        </div>
        <app-validation-errors [control]="representationForm.get('name')"></app-validation-errors>
      </div>

      <div class="col-12 md:col-12 lg:col-6 xl:col-4">
        <div class="form-field col-12">
          <label for="description">{{ 'attribute.description' | transloco }}</label>
        </div>
        <div class="col-12">
          <input class="w-full" formControlName="description" id="description" pInputText type="text">
        </div>
      </div>

      <div class="col-12 md:col-12 lg:col-6 xl:col-4">
        <div class="form-field col-12">
          <label for="tenant">{{ 'model.tenant' | transloco }} (*)</label>
        </div>
        <div class="col-12">
          <p-dropdown
            [filter]="true"
            [options]="tenants"
            [placeholder]="'select.tenant' | transloco"
            formControlName="tenant"
            id="tenant"
            optionLabel="name"
            styleClass="w-full"
          ></p-dropdown>
        </div>
      </div>

      <div class="col-12 md:col-12 lg:col-6 xl:col-4">
        <div class="form-field col-12">
          <label for="tenant">{{ 'attribute.icon' | transloco }}</label>
        </div>
        <div class="col-12 flex flex-column">
          <div class="mb-2">
            <label class="cursor-pointer p-button mr-2" pRipple>
              {{ 'primeng.upload' | transloco }}<i class="pi pi-upload ml-2" style="font-size: 14px;"></i>
              <input #imageInput (change)="onUploadIcon(imageInput)" accept="image/*" class="hidden" type="file">
            </label>
          </div>
          <div>
          </div>
        </div>
      </div>

      <div class="col-12 md:col-12 lg:col-6 xl:col-4">
        <div class="form-field col-12">
          <label for="tenant">{{ 'attribute.targetColor' | transloco }}</label>
        </div>

        <div class="col-12 flex flex-column">
          <!-- USELESS COLOR-PICKER ONLY FOR VISUAL STYLE COHERENCE -->
          <app-color-picker
            *ngIf="!icon"
            [color]="mapIconService.DEFAULT_NEW_ICON_MAIN_COLOR"
            [disabled]="true"
          ></app-color-picker>

          <!-- REAL COLOR-PICKER -->
          <app-color-picker
            (colorChange)="targetIconColor = $event; loadUploadImage()"
            *ngIf="icon"
            [changeDelay]="1"
            [color]="targetIconColor"
            [disabled]="false"
            [showClear]="true"
          ></app-color-picker>
        </div>
      </div>

      <div class="col-12">
        <div class="form-field col-12">
          <label for="tenant">{{ 'common.preview' | transloco }}</label>
        </div>

        <div *ngIf="mapIconService.getNewDefaultIcon()" class="col-12 flex flex-column gap-2">
          <div class="flex flex-row justify-content-around gap-2 flex-wrap">
            <div class="flex text-center flex-column justify-content-center">
              <span>{{ "misc.representation.default" | transloco }}</span>
              <img #target
                   class="h-auto w-6rem"
                   [alt]="'attribute.icon' | transloco"
                   [src]=" icon ?? 'data:image/png;base64,' +mapIconService.getNewDefaultIcon()"
                   style="max-height: 150px;">

            </div>
            <ng-container *ngFor="let type of imageStatusTypes; let i = index">
              <div class="flex flex-column text-center justify-content-center">
                <span>{{ "misc.representation." + type.toLowerCase() | transloco }}</span>
                <img *ngIf="!loadingIcons"
                     [alt]="'attribute.icon' | transloco"
                     class="h-auto w-6rem"
                     [src]="imageStatusSources?.get(type)?.img"
                     style="max-height: 150px;">

                <p-skeleton *ngIf="loadingIcons" [height]=" (target?.height ?? 150) + 'px'"
                            [width]="(target?.width ?? 150) + 'px'"></p-skeleton>
              </div>

            </ng-container>
          </div>
        </div>
      </div>

    </div>
  </form>
  <div class="mt-auto">
    <div class="flex justify-content-between mt-4">
      <button
        [label]="'common.cancel' | transloco"
        [routerLink]="'/system/asset-representations'"
        class="p-button-danger"
        iconPos="right"
        pButton
      ></button>
      <p-button
        (onClick)="persistRepresentationData()"
        *ngIf="representationForm"
        [disabled]="!representationForm.valid"
        [label]="(mode == 'creation' ? 'common.create' : 'common.save') | transloco"
        [loading]="persistingChanges"
        class="mr-2"
        styleClass="p-button-primary"
      ></p-button>
    </div>
  </div>
</div>
